import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import SquadNavigator from "../../../navigation/SquadNavigator";
import styles from "./squadSettings.module.css";

const SquadSettings = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/squads/show-all-squads">
              عرض جميع السكوادات
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/squads/control-squad-banners">
              إنشاء بانر سكواد
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <SquadNavigator />
    </div>
  );
};

export default SquadSettings;
